import React from "react";
import CustomWorkflowCard from "./CustomWorkflowCard";
import CustomFieldsCard from "./CustomFieldsCard";
import CustomIntegrationCard from "./CustomIntegrationCard";
import CustomReportCard from "./CustomReportCard";

export default function Phase6Cards({ merchant }) {
  return (
    <>
      <CustomWorkflowCard />
      <CustomFieldsCard merchant={merchant} />
      <CustomIntegrationCard />
      <CustomReportCard />
    </>
  );
}
